import React, { FC, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../_metronic/layout/core'
import AutoComplete3 from '../AddressAutoComplete3';
import Select from 'react-select';
import { fetchData, getTranslatedValue, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddSpaceHeader } from './AddSpaceHeader';
import GoogleMapComponent2 from '../GoogleMapComponent2';
import { Tr } from '../../../_metronic/i18n/Tr';
import Swal from 'sweetalert2';
import { KTIcon } from '../../../_metronic/helpers';
import { useLang } from '../../../_metronic/i18n/Metronici18n';

const AddSpaceLocation: FC = () => {

    const t = Tr()
    const lang = useLang()
    const navigate = useNavigate()
    const categoryId = sessionStorage.getItem('categoryId')
    useEffect(() => {
        if (categoryId != '4') {
            navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editSpacerentalId = (location.state as any)?.spacerentalId || '';
    const [spaceRenatalDetails, setSpacerentalDetails] = useState([]);
    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;

    } else {
        console.log("No vendor data found");
    }
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [country, setCountry] = useState("");
    const [state, setState] = useState("");
    const [city, setCity] = useState("");
    const [address, setAddress] = useState("");
    const [longitude, setLongitude] = useState("");
    const [latitude, setLatitude] = useState("");
    const [locationObj, setLocationObj] = useState(null) as any;
    const [businessZipCode, setBusinessZipCode] = useState("");
    const [businessAddressLine1, setBusinessAddressLine1] = useState("");
    const [businessAddressLine2, setBusinessAddressLine2] = useState("");
    const [businessCountryList, setBusinessCountryList] = useState([]);
    const [businessCountrySelectedOptions, setBusinessCountrySelectedOptions] = useState<any>();
    // region list state start
    const [regionList, setRegionList] = useState([]);
    const [regionSelectedOptions, setRegionSelectedOptions] = useState<any>([]);
    const primaryLanguage = localStorage.getItem("primaryLanguage");
    const [isFieldDisable, setIsFieldDisable] = useState({
        businessAddress: false,
    }) as any

    const countryListAPIcall = async () => {

        var res = await fetchData("public/countryList", [])

        if (res.status == "200") {
            var opt: any = []
            res.data.map((val: any) => {
                opt.push({ value: val.countryId, label: val.nicename })
            })

            setBusinessCountryList(opt)
        }
        else {
            toasterrormsg(res.message)
        }
    }
    //   region list api call
    const regionListAPIcall = async () => {

        var res = await fetchData("public/regionList", [])

        if (res.status == "200") {
            var opt: any = []
            res.data.map((val: any) => {
                opt.push({ value: val.regionId, label: getTranslatedValue(lang, val, '_name') })
            })

            setRegionList(opt)
        }
        else {
            toasterrormsg(res.message)
        }
    }
    useEffect(() => {
        countryListAPIcall();
        regionListAPIcall();
    }, [])
    useEffect(() => {
        if (locationObj) {
            setCountry(locationObj.country);
            setState(locationObj.state);
            setCity(locationObj.city);
            setAddress(locationObj.location);
            setLatitude(locationObj.latitude);
            setLongitude(locationObj.longitude);
        }
    }, [locationObj]);


    // set error state
    const [error, setError] = useState([{
        address: '',
        businessCountry: '',
        regionId: '',
        businessZipCode: '',
        businessAddressLine1: '',
    }])

    // remove validation function
    const removeError = (err: any) => {
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }

    // validation function
    const validate = () => {

        var isValid = true;
        var errorTmp = [...error];

        if (address == "" || address == null || address == undefined) {
            errorTmp[0].address = t('Location Is Required');
            isValid = false;
        }
        if (businessCountrySelectedOptions == "" || businessCountrySelectedOptions == null || businessCountrySelectedOptions == undefined) {
            errorTmp[0].businessCountry = t('Country Is Required');
            isValid = false;
        }
        if (regionSelectedOptions == "" || regionSelectedOptions == undefined || regionSelectedOptions == null) {
            errorTmp[0].regionId = t('Region Is Required');
            isValid = false;
        }
        if (businessZipCode == "" || businessZipCode == null || businessZipCode == undefined) {
            errorTmp[0].businessZipCode = t('Zip Code Is Required');
            isValid = false;
        }
        if (businessAddressLine1 == "" || businessAddressLine1 == null || businessAddressLine1 == undefined) {
            errorTmp[0].businessAddressLine1 = t('Address Line 1 Is Required');
            isValid = false;
        }

        setError(errorTmp);
        return isValid;
    }
    // add space location api call
    const addspaceLocationApi = async () => {

        if (validate()) {

            setDisable(true)
            setLoading(true);
            var param: any = {
                spacerentalId: String(editSpacerentalId),
                address: address,
                longitude: longitude,
                latitude: latitude,
                country: country,
                state: state,
                city: city,
                countryId: String(businessCountrySelectedOptions.value),
                region: String(regionSelectedOptions.value),
                addressline1: businessAddressLine1,
                addressline2: businessAddressLine2,
                zipcode: businessZipCode
            }
            var response: any = await fetchData("public/addSpaceRentalLocation", param)
            if (response.status == "200") {
                toastsuccessmsg(t("Location Added Successfully!"))
                const state = {
                    spacerentalId: editSpacerentalId
                }
                setTimeout(() => {
                    navigate("../addspacedetails/", { state });
                    setDisable(false)
                }, 1500);
            }
            else {
                toasterrormsg(response.message)
                setDisable(false)
            }
        }
    }


    // space Details api call
    const spaceDetailsApiCall = async () => {

        var param: any = {
            spacerentalId: String(editSpacerentalId),
        }
        var response: any = await fetchData("public/spaceDetails", param)

        if (response.status == "200") {
            var spacedata = response.data;
            const isAllStepsCompleted = Object.values(spacedata[0]['completedSteps']).every(s => s == true)
            if (isAllStepsCompleted && editSpacerentalId !== "") {
                // Set all fields to true
                setIsFieldDisable((prev: any) => {
                    const updatedFields = {} as any;
                    for (const key in prev) {
                        updatedFields[key] = true;
                    }
                    return updatedFields;
                });
            }
            var vendorData = spacedata[0]['vendorDetails'][0]
            setSpacerentalDetails(spacedata);
            setAddress(spacedata[0].location)
            setLatitude(spacedata[0].latitude)
            setLongitude(spacedata[0].longitude)
            setState(spacedata[0].state)
            setCity(spacedata[0].city)
            setCountry(spacedata[0].country)
            setBusinessAddressLine1(vendorData.addressline1)
            setBusinessAddressLine2(vendorData.addressline2)
            setBusinessZipCode(vendorData.zipcode)
            var country: any = []
            vendorData.country.map((val: any) => {
                country.push({ value: val.countryId, label: val.nicename })
            })
            var region: any = []
            vendorData.regionDetail.map((val: any) => {
                region.push({ value: val.regionId, label: getTranslatedValue(lang, val, '_name', primaryLanguage) })
            })
            setRegionSelectedOptions(region[0] ? region[0] : [])
            setBusinessCountrySelectedOptions(country[0])
        }
        else {
            toasterrormsg(response.message)
        }
    }

    useEffect(() => {
        if (editSpacerentalId != "") {
            spaceDetailsApiCall();
        }
    }, [])

    const criticalFieldChange = (field: string) => {
        Swal.fire({
            title: t('Please note that modifying this detail will require the preparation and signing of a new contract to ensure all parties are in agreement with the revised terms!'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: t('Ok'),
            cancelButtonText: t('Cancel'),
        }).then(async (result) => {
            if (result.isConfirmed) {
                setIsFieldDisable((prev: any) => ({
                    ...prev,
                    [field]: false,
                }));
            }
        });
    }
    return (
        <>
            <ToastContainer />
            <PageTitle breadcrumbs={[]}>{editSpacerentalId != "" ? t('Edit Location') : t('Add Location')}</PageTitle>
            <AddSpaceHeader spacerentalId={editSpacerentalId} />
            <div className="d-flex flex-column flex-column-fluid">
                {/* <!--begin::Content--> */}
                <div id="kt_app_content" className="app-content flex-column-fluid">
                    {/* <!--begin::Form--> */}
                    <div className="form d-flex flex-column flex-lg-row">
                        {/* <!--begin::Main column--> */}
                        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                            {/* <!--begin::Tab content--> */}
                            <div className="tab-content">
                                {/* <!--begin::Tab pane--> */}
                                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">

                                    <div className="d-flex flex-column">
                                        {/* <!--begin::General options--> */}
                                        <div className="card card-flush py-4">
                                            {/* <!--begin::Card header--> */}
                                            <div className="card-header d-flex">
                                                {/* <!--begin::Card title--> */}
                                                <div className="card-title">
                                                    <h2>{t('Space Location')}</h2>
                                                </div>
                                                {/* <!--end::Card title--> */}
                                                <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                                    {
                                                        spaceRenatalDetails.length != 0 ? (
                                                            <>
                                                                {
                                                                    spaceRenatalDetails.map((completedSteps: any, index: any) => {
                                                                        var percentage = 0;
                                                                        if (completedSteps['completedSteps']['basicInfo']) {
                                                                            percentage = 10;
                                                                        }
                                                                        if (completedSteps['completedSteps']['location']) {
                                                                            percentage = 20;
                                                                        }
                                                                        if (completedSteps['completedSteps']['propertyDetail']) {
                                                                            percentage = 40;
                                                                        }
                                                                        if (completedSteps['completedSteps']['rentableSpace']) {
                                                                            percentage = 50;
                                                                        }
                                                                        if (completedSteps['completedSteps']['photos']) {
                                                                            percentage = 60;
                                                                        }
                                                                        if (completedSteps['completedSteps']['facilitiesAndServices']) {
                                                                            percentage = 70;
                                                                        }
                                                                        if (completedSteps['completedSteps']['availability']) {
                                                                            percentage = 80;
                                                                        }
                                                                        if (completedSteps['completedSteps']['policies']) {
                                                                            percentage = 90;
                                                                        }
                                                                        if (completedSteps['completedSteps']['financeAndLegal']) {
                                                                            percentage = 100;
                                                                        }
                                                                        return (
                                                                            <React.Fragment key={index}>
                                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                                    <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                                </div>
                                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                                    <div
                                                                                        className='bg-success rounded h-5px'
                                                                                        role='progressbar'
                                                                                        style={{ width: `${percentage}%` }}
                                                                                    ></div>
                                                                                </div>
                                                                            </React.Fragment>
                                                                        )
                                                                    })
                                                                }
                                                            </>
                                                        ) : (
                                                            <>
                                                                <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                    <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                    <span className='fw-bolder fs-6'>0%</span>
                                                                </div>
                                                                <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                    <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{ width: '0%' }}
                                                                    ></div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                            {/* <!--end::Card header--> */}
                                            {/* <!--begin::Card body--> */}
                                            <div className="card-body pt-10">
                                                {/* <!--begin::Input group--> */}
                                                <div className="row">
                                                    <div className="col-lg-6 my-3">
                                                        <label className="required fs-4 form-label">{t('Location')}</label>
                                                        <AutoComplete3 name="location" id="location" placeholder={t("Enter Location")} value={address} onAddressSelect={(address: any) => { setAddress(address); removeError("address"); }} longitude={(lng: any) => setLongitude(lng)} latitude={(lat: any) => setLatitude(lat)} country={(cnt: any) => setCountry(cnt)} state={(st: any) => setState(st)} city={(ct: any) => setCity(ct)} />
                                                        <div className='text-danger fw-bold'>{error[0].address}</div>
                                                        <br />
                                                        <GoogleMapComponent2 latitude={latitude} longitude={longitude} onSelectLocation={(e: any) => setLocationObj(e)} />
                                                    </div>
                                                    <div className="col-lg-6 my-3">
                                                        <div className="row">
                                                            <label className='fw-bolder text-dark fs-4'>{t('Business Address')}<button type='button' className='btn btn-sm bg-light-primary bg-hover-success text-hover-white p-1 ms-3' onClick={() => criticalFieldChange('businessAddress')}><KTIcon iconName='notepad-edit' className='ps-1 pb-1'></KTIcon></button></label>
                                                        </div>
                                                        <div className='fv-row mb-8 mt-4'>
                                                            <label className='required fs-4 form-label'>{t('Country')}</label>
                                                            {/* <!--begin::Input--> */}
                                                            <Select
                                                                name='businessCountry'
                                                                id='businessCountry'
                                                                placeholder={t('Select Country')}
                                                                isSearchable={true}
                                                                isDisabled={isFieldDisable.businessAddress}
                                                                options={businessCountryList}
                                                                value={businessCountrySelectedOptions}
                                                                onChange={(e: any) => { setBusinessCountrySelectedOptions(e); removeError("businessCountry"); }}
                                                            />
                                                            {/* <!--end::Input--> */}
                                                            <div className='text-danger fw-bold'>{error[0].businessCountry}</div>
                                                        </div>
                                                        <div className="fv-row mb-8 mt-4">
                                                            <label className="required fs-4 form-label">{t('Region')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <Select
                                                                name='region[]'
                                                                id='regionListId'
                                                                placeholder={t('Select Region')}
                                                                isSearchable={true}
                                                                options={regionList}
                                                                isDisabled={isFieldDisable.businessAddress}
                                                                value={regionSelectedOptions}
                                                                onChange={(e: any) => { setRegionSelectedOptions(e); removeError("regionId"); }}
                                                            />
                                                            <div className='text-danger fw-bold'>{error[0].regionId}</div>
                                                        </div>
                                                        <div className='fv-row mb-8'>
                                                            <label className='required fs-4 form-label'>{t('Address Line 1')}</label>
                                                            {/* <!--begin::Input--> */}
                                                            <input type="text" name="businessAddressLine1" id='businessAddressLine1' disabled={isFieldDisable.businessAddress} className="form-control mb-2" placeholder={t("Address Line 1")} value={businessAddressLine1} onChange={(e) => { setBusinessAddressLine1(e.target.value); removeError("businessAddressLine1"); }} />
                                                            {/* <!--end::Input--> */}
                                                            <div className='text-danger fw-bold'>{error[0].businessAddressLine1}</div>
                                                        </div>
                                                        <div className='fv-row mb-8'>
                                                            <label className='fs-4 form-label'>{t('Address Line 2 (optional)')}</label>
                                                            {/* <!--begin::Input--> */}
                                                            <input type="text" name="businessAddressLine2" id='businessAddressLine2' disabled={isFieldDisable.businessAddress} className="form-control mb-2" placeholder={t("Address Line 2")} value={businessAddressLine2} onChange={(e) => { setBusinessAddressLine2(e.target.value); removeError("businessAddressLine2"); }} />
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                        <div className='fv-row mb-8'>
                                                            <label className='required fs-4 form-label'>{t('Zip Code')}</label>
                                                            {/* <!--begin::Input--> */}
                                                            <input type="text" name="businessZipCode" id='businessZipCode' disabled={isFieldDisable.businessAddress} className="form-control mb-2" placeholder={t("Zip Code")} value={businessZipCode} onChange={(e) => { setBusinessZipCode(e.target.value); removeError("businessZipCode"); }} />
                                                            {/* <!--end::Input--> */}
                                                            <div className='text-danger fw-bold'>{error[0].businessZipCode}</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {/* <!--end::Input group--> */}
                                            </div>
                                            {/* <!--begin::Card body--> */}
                                        </div>
                                        {/* <!--end::Pricing--> */}
                                    </div>
                                </div>
                                {/* <!--end::Tab pane--> */}
                            </div>
                            {/* <!--end::Tab content--> */}
                            <div className="d-flex justify-content-end">
                                {/* <!--begin::Button--> */}
                                <button type="button" disabled={disable} className="btn btn-primary" onClick={addspaceLocationApi}>
                                    <span className="indicator-label">{t('Next')}</span>
                                    {loading && (
                                        <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                                    )}
                                </button>
                                {/* <!--end::Button--> */}
                            </div>
                        </div>
                        {/* <!--end::Main column--> */}
                    </div>
                    {/* <!--end::Form--> */}
                </div>
                {/* <!--end::Content--> */}
            </div>
        </>
    )
}

export { AddSpaceLocation }
